export const FinancialAccountUpdateBalancesEvent = {
  START: 'FinancialAccountUpdateBalancesEvent:START',
  END: 'FinancialAccountUpdateBalancesEvent:END'
};
